import I18n from 'I18n';
import { useSelector, useDispatch } from 'react-redux';
import { isAllOpenView, isSentView, isThreadList, getViewOrderedBy } from 'find-and-filter-data/views-schema/public';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { getThreadListMembersWithOverlays } from '../../thread-list-member/selectors/getThreadListMembersWithOverlays';
import { Select } from 'foundations-components/transitional/components/Select';
import { useSortOrder } from '../hooks/useSortOrder';
import { addAllThreadListMembersToBatchGroup } from '../../thread-list-member-sidebar/actions/threadListMemberBatchUpdatesActions';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getSorted } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { useStatusToggle } from '../hooks/useStatusToggle';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
import { useInboxViewMembers } from 'find-and-filter-data/view-members-data/public';
import { getCurrentViewId } from '../../thread-list/selectors/getCurrentViewId';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { StatusToggle } from './StatusToggle';
import { getViewMemberId } from 'find-and-filter-data/view-members-schema/public';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RealtimeThreadListHeader = () => {
  const {
    sortOrder,
    setSortOrder
  } = useSortOrder();
  const {
    statusToggle
  } = useStatusToggle();
  const inboxId = useSelector(getCurrentInboxId);
  const viewId = useSelector(getCurrentViewId);
  const {
    isInitialPageReceived,
    viewMembers
  } = useInboxViewMembers({
    inboxId,
    skip: true,
    sortDirection: sortOrder,
    threadStatus: statusToggle,
    viewId: viewId || undefined
  });
  const currentView = useCurrentView();
  const threadListMembers = useSelector(state => getThreadListMembersWithOverlays(state, {
    isInitialPageReceived,
    viewMembers,
    viewOrderBy: getViewOrderedBy(currentView)
  }));
  const dispatch = useDispatch();
  const isInSentView = isSentView(currentView);
  const addThreadListMembersToBatchGroup = () => {
    const tlms = threadListMembers.filter(tlm => {
      try {
        return Boolean(tlm) && getViewMemberId(tlm);
      } catch (e) {
        return false;
      }
    }).map(threadListMember => +getViewMemberId(threadListMember));
    dispatch(addAllThreadListMembersToBatchGroup(tlms));
  };
  const disabled = !threadListMembers || threadListMembers.size === 0;
  const shouldRenderStatusToggle = isThreadList(currentView) && !isAllOpenView(currentView);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    inlineSize: "100%",
    blockSize: "40px",
    flexGrow: 1,
    flexShrink: 1,
    marginInlineStart: "100",
    children: [/*#__PURE__*/_jsxs(Box, {
      display: "flex",
      padding: "100",
      alignItems: "center",
      shrink: 0,
      children: [/*#__PURE__*/_jsx(Checkbox, {
        "aria-label": I18n.text('conversations-inbox-ui.thread-search-and-filtering.thread-list-member-sidebar.label'),
        "data-test-id": "bulk-select-all-threads",
        disabled: disabled,
        checked: false,
        onClick: addThreadListMembersToBatchGroup,
        marginInlineEnd: "400"
      }), shouldRenderStatusToggle && /*#__PURE__*/_jsx(Box, {
        shrink: 0,
        children: /*#__PURE__*/_jsx(StatusToggle, {})
      })]
    }), /*#__PURE__*/_jsx(Select, {
      disabled: disabled,
      buttonUse: "transparent",
      onChange: evt => {
        setSortOrder(evt.target.value);
        trackEvent(getSorted({
          sortOrder: evt.target.value,
          isSentView: isInSentView
        }));
      },
      options: [{
        text: I18n.text('conversations-inbox-ui.thread-search-and-filtering.sorting.descending'),
        value: 'DESC'
      }, {
        text: I18n.text('conversations-inbox-ui.thread-search-and-filtering.sorting.ascending'),
        value: 'ASC'
      }],
      value: sortOrder
    })]
  });
};
RealtimeThreadListHeader.displayName = 'RealtimeThreadListHeader';
export default RealtimeThreadListHeader;